/**
 * Header variants that are their own component. Anything not listed renders
 * through the original Header.tsx, which handles the five founding variants
 * with internal branching. Adding a header design = one file + one line here;
 * the knob value itself lives in the registry package (KNOB_VALUES).
 */
import type { ComponentType } from 'react';
import type { HeaderVariant } from '@/looks';
import type { HeaderProps } from '../Header';
import FloatingGlassHeader from './FloatingGlassHeader';

export const HEADER_VARIANT_COMPONENTS: Readonly<Partial<Record<HeaderVariant, ComponentType<HeaderProps>>>> = {
  floating_glass: FloatingGlassHeader,
};
